"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const textWidget_1 = __importDefault(require("./textWidget"));
/**
 * If no UISchema is specified for this widget, it will default to
 * the checkbox widget styling.
 * If no enumNames property has been set in JSONSchema, it will default to 'yes' or 'no' values.
 */
const Radio = ({ value = '', ...rest }) => {
    const { enumOptions } = rest.options;
    const selectedOption = enumOptions.find(option => option.value === value) || {
        label: value
    };
    return jsx_runtime_1.jsx(textWidget_1.default, Object.assign({ value: selectedOption.label }, rest), void 0);
};
exports.default = Radio;
//# sourceMappingURL=radio.js.map